export default __webpack_public_path__ + "static/media/mechanic-4.b5193a04.jpg";